import {convertLocationParamsToFetchParams} from 'app/documents/api';
import {selectDocumentFilters, setDocumentFilters} from 'app/documents/slice';
import {useAsyncActions} from 'app/utils/redux';

import {useGenericFilters} from '../hooks';

import type {DocumentFetchParamsType} from './types';
import type {Location} from 'history';
import type {InjectedRouter} from 'react-router/lib/Router';

export function useDocumentDashboardFilters(
  location: Location<DocumentFetchParamsType>,
  router: InjectedRouter
) {
  const {
    filters,
    params,
    viewingAll,
    resetFilters: resetFiltersFromGeneric,
    setFilters,
  } = useGenericFilters(
    location,
    router,
    selectDocumentFilters,
    useAsyncActions({
      setDocumentFilters,
    }).setDocumentFilters,
    convertLocationParamsToFetchParams
  );
  const resetFilters = () => {
    if (location.query.folder != null && location.query.folder) {
      setFilters({} as DocumentFetchParamsType);
      router.replace({
        pathname: location.pathname,
        query: {folder: location.query.folder},
      });
    } else {
      resetFiltersFromGeneric();
    }
  };

  return {
    filters: {
      ...location.query,
      ...filters,
      folder: location.query.folder,
    },
    params,
    viewingAll,
    resetFilters,
  };
}
